import { styled } from '@linaria/react';
import ContentWrapper from '@vio/atlas/helpers/ContentWrapper';
import { Grid } from '@vio/atlas/helpers/Grid/Grid';
import { Radio } from '@vio/atlas/Radio';
import { Text } from '@vio/atlas/Text';
const _exp = /*#__PURE__*/() => ContentWrapper;
export const PageWrapper = /*#__PURE__*/styled(_exp())({
  name: "PageWrapper",
  class: "py6ja2k",
  propsAsIs: true
});
export const RadioGroup = /*#__PURE__*/styled('div')({
  name: "RadioGroup",
  class: "r8fvrye",
  propsAsIs: false
});
const _exp4 = /*#__PURE__*/() => Text;
export const PageTitle = /*#__PURE__*/styled(_exp4())({
  name: "PageTitle",
  class: "pyb45dn",
  propsAsIs: true
});
const _exp6 = /*#__PURE__*/() => Text;
export const PageSubtitle = /*#__PURE__*/styled(_exp6())({
  name: "PageSubtitle",
  class: "p1qynl4v",
  propsAsIs: true
});
export const DescriptionWrapper = /*#__PURE__*/styled('div')({
  name: "DescriptionWrapper",
  class: "dc0xmf1",
  propsAsIs: false
});
const _exp13 = /*#__PURE__*/() => Grid;
export const RouteInfoContainer = /*#__PURE__*/styled(_exp13())({
  name: "RouteInfoContainer",
  class: "ropwa0c",
  propsAsIs: true
});
const _exp17 = /*#__PURE__*/() => Radio;
export const CustomRadio = /*#__PURE__*/styled(_exp17())({
  name: "CustomRadio",
  class: "c1szk9w9",
  propsAsIs: true
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");